import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import CoachIcon from "@mui/icons-material/Chat";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import * as AdminSessionActions from "../../state/redux/adminSession";
import * as PracticeSessionActions from "../../state/redux/practiceSession";
import { deepCopyObject } from "../../utils/helpers";
import PracticeConversationConfigurationsDialog from "../dialogs/practiceConversationConfigurationsDialog";
import OmniAvatar from "../ui/omniAvatar";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const PracticeConversationConfigurations = props => {
  const {
    relatedConversationConfigurationODMs,
    conversationConfigurationODMs,
    loadConversationConfigurationsRequest,
  } = props;

  const [selectedConversationConfigurations, setSelectedConversationConfigurations] =
    useState(null);

  useEffect(() => {
    // actions were closed while navigation state was not reset
    if (!conversationConfigurationODMs) {
      //load it
      loadConversationConfigurationsRequest();
    }
  }, [conversationConfigurationODMs, loadConversationConfigurationsRequest]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (relatedConversationConfigurationODMs != null) {
      setTitleText(
        `${relatedConversationConfigurationODMs.length} Conversation${
          relatedConversationConfigurationODMs.length === 1 ? `` : `s`
        }`,
      );
    } else setTitleText("");
  }, [relatedConversationConfigurationODMs]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle
        title={"Botpress"}
        text={titleText}
        loading={relatedConversationConfigurationODMs == null}
      >
        <OmniResponsiveButton
          tooltipTitle={
            !conversationConfigurationODMs ? "" : "Add a assessment template for this practice"
          }
          buttonText="Conversations"
          disabled={!conversationConfigurationODMs}
          onClick={() => {
            setSelectedConversationConfigurations(
              props.practiceODM.omniRelationships.conversationConfigurations.slice(),
            );
          }}
        />
      </WidgetTitle>

      {relatedConversationConfigurationODMs == null && <WidgetSkeleton />}
      {relatedConversationConfigurationODMs != null && (
        <WidgetList>
          {relatedConversationConfigurationODMs.map((conversationConfiguration, index) => {
            return (
              <ListItem
                key={`conversationConfiguration${index}`}
                disableGutters={true}
                sx={{
                  padding: theme.spacing(1),
                  paddingTop: 0,
                  paddingBottom: 0,
                  marginBottom: theme.spacing(1),
                  borderRadius: theme.spacing(1),
                  backgroundColor: alpha(theme.palette.info.main, 0.75),
                  color: theme.palette.info.contrastText,
                  boxShadow: theme.shadows[3],
                  userSelect: "none",
                  webkitUserSelect: "none",
                }}
              >
                <Tooltip title={"No Notes"} placement="right">
                  <OmniAvatar
                    sx={{
                      width: 36,
                      height: 36,
                      fontSize: "1.8rem",
                      border: `2px solid ${theme.palette.info.contrastText}`,
                    }}
                  >
                    <CoachIcon />
                  </OmniAvatar>
                </Tooltip>
                <ListItemText
                  primary={
                    <Typography
                      variant="h6"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: theme.spacing(1),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: theme.palette.info.contrastText,
                        marginTop: 0,
                      }}
                    >
                      {conversationConfiguration.omniData.botName}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="body2"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: theme.spacing(1),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        marginTop: "-6px",
                        color: theme.palette.info.contrastText,
                        minimumHeight: 20,
                      }}
                    >
                      {conversationConfiguration.omniData.conversationName}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
        </WidgetList>
      )}

      {selectedConversationConfigurations && (
        <PracticeConversationConfigurationsDialog
          open={selectedConversationConfigurations != null}
          omniDMO={deepCopyObject(selectedConversationConfigurations)}
          associatedConfigurations={selectedConversationConfigurations}
          allConfigurations={conversationConfigurationODMs}
          onAccept={associatedConversations => {
            props.associateConversationConfigurationsRequest(associatedConversations);
            setSelectedConversationConfigurations(null);
          }}
          onClose={() => {
            setSelectedConversationConfigurations(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  relatedConversationConfigurationODMs: state.practiceSession.relatedConversationConfigurationODMs,
  practiceODM: state.practiceSession.practiceODM,
  conversationConfigurationODMs: state.adminSession.conversationConfigurationODMs,
});

const mapDispatchToProps = {
  associateConversationConfigurationsRequest:
    PracticeSessionActions.associateConversationConfigurationsRequest,
  removeConversationConfigurationRequest:
    PracticeSessionActions.removeConversationConfigurationRequest,
  loadConversationConfigurationsRequest: AdminSessionActions.loadConversationConfigurationsRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(PracticeConversationConfigurations);
